module.exports = __webpack_public_path__ + "static/img/12bg_3.bc9f72a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_3.png
// module id = 642
// module chunks = 1